import "tailwindcss/tailwind.css";
import { Link, Route, Routes } from "react-router-dom";
import useTitle from "@/hooks/useTitle";
import MainLayout from "@/layouts/MainLayout";
import PolicyLayout from "@/layouts/PolicyLayout";
import DashboardLayout from "@/layouts/DashboardLayout";
import Home from "@/pages/home";
import Business from "@/pages/business";
import Checkout from "@/pages/checkout";
import Orders from "@/pages/dashboard/orders";
import Account from "@/pages/dashboard/account";
import Dashboard from "@/pages/dashboard";
import Auth from "@/pages/auth";
import Order from "@/pages/order";
import NotFound from "@/pages/404";
import Terms from "./pages/policy/Terms";
import Privacy from "./pages/policy/Privacy";
import Refund from "./pages/policy/Refund";
import Cookie from "./pages/policy/Cookie";
// import Test from "@/pages/test";

export default function App() {
  useTitle("online ordering");

  return (
    <Routes>
      <Route path="/:businessName/" element={<MainLayout />}>
        <Route index element={<Business />} />
        <Route path="checkout" element={<Checkout />} />
        {/* <Route path="test" element={<Test />} /> */}
        <Route path="order" element={<Order />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      {/* <Route path="auth" element={<Auth />} /> */}
      <Route path="/policy/" element={<PolicyLayout />}>
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="refund" element={<Refund />} />
        <Route path="cookie" element={<Cookie />} />
      </Route>
      <Route path="/dashboard/" element={<DashboardLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<Orders />} />
        <Route path="account" element={<Account />} />
      </Route>
      <Route path="/" element={<Home />} />
    </Routes>
  );
}
